// extracted by mini-css-extract-plugin
module.exports = {"subtitle":"subtitle_subtitle__LiXvu","subtitleV2":"subtitle_subtitleV2__SQq4X"};